<template>
  <div>
    <ConfirmModal
      :is-open="deleteEntryDialog"
      :confirm-header-text="isDisabled ? $nt('enableHeader') : $nt('disableHeader')"
      :confirm-body-text="isDisabled ? $nt('enableBody') : $nt('disableBody')"
      :confirm-button-color="isDisabled ? 'success' : 'error'"
      :confirm-button-text="isDisabled ? $nt('enable') : $nt('disable')"
      :is-loading="isLoading"
      @confirm="toggleAgent"
      @dialogToggle="val => deleteEntryDialog = val"
    />

    <VCard>
      <VCardTitle>
        <span class="headline">
          {{ $nt('headline') }}
        </span>
      </VCardTitle>
      <VCardText>
        <p v-if="isDisabled">
          {{ $nt('enableUserWarn') }}
        </p>
        <p v-else>
          {{ $nt('disableUserWarn') }}
        </p>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          :color="isDisabled ? 'primary' : 'error'"
          :disabled="deleteEntryDialog"
          @click.native="deleteEntryDialog = true"
        >
          <span v-if="isDisabled">
            {{ $nt('enableButton') }}
          </span>
          <span v-else>
            {{ $nt('disableButton') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>

<script>
import ConfirmModal from '@/components/global-components/confirmModal/ConfirmModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AgentDisable',
  components: { ConfirmModal },
  props: ['agentId'],
  data () {
    return {
      deleteEntryDialog: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('agent', ['currentAgent']),
    isDisabled () {
      return this.currentAgent.status.name === 'blocked'
    }
  },
  methods: {
    ...mapActions('agent', ['disableAgent', 'enableAgent']),
    async toggleAgent () {
      this.isLoading = true
      try {
        const response = this.isDisabled
          ? await this.enableAgent({ agent: this.currentAgent })
          : await this.disableAgent({ agent: this.currentAgent })
        this.deleteEntryDialog = false
        this.$notification(response)
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  }
}
</script>
